export var selectRaw = function selectRaw(state) {
  return state.gandiReduxBilling;
};
export var hashString = function hashString(str) {
  return String(str.split('').reduce(function (prevHash, currVal) {
    return (
      // eslint-disable-next-line no-bitwise,no-mixed-operators
      Math.abs((prevHash << 5) - prevHash + currVal.charCodeAt(0))
    );
  }, 0));
};
export var selectSharingIdProp = function selectSharingIdProp(_, props) {
  return props.sharingId;
};